import { FC, useState , useEffect} from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import CustomControls from "./rteCustomControl";
import Icon from "@assets/icon_config";
import { getNoteMaxLength } from "@utils/helpers";

type CustomControlType = {
  showCustomControls: boolean;
  bookmarkStatus?: any;
  setBookmarkStatus?: any;
  recipientType?: any;
  setRecipientType?: any;
};

type RTEProps = {
  changeHandler: (f: any) => void;
  content?: any;
  disabled?: any;
  wordLimit?: number;
  showCount?: Boolean;
  placeHolder?: any;
  actionsMenu?: any;
  autoFocus?: any;
  editMode?: any;
  customControlData?: CustomControlType;
};

const RichTextEditor: FC<RTEProps> = ({
  changeHandler,
  content,
  customControlData,
  editMode,
  actionsMenu,
  autoFocus = true,
  disabled,
  wordLimit = getNoteMaxLength(),
  showCount,
  placeHolder = "Enter Some Text",
}: RTEProps) => {
  const [editorText, setEditorText] = useState('');
  const toolbarOptions = ["bold", "italic", "underline", "link"];
  const textValue = editorText.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ");
  const Link = Quill.import('formats/link');

  // link sanitized for protocol
  Link.sanitize = (url: any) => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return `https://${url}`;
    }
    return url;
  };

  useEffect(() => {
    setEditorText(content);
  },[content])

  const handleEditorChange = (value: any) => {
    const modifiedContent = value.replace(/<span style="color: rgb\(0, 0, 0\);">(.*?)<\/span>/g, "<span>$1</span>").replace(/<strong style="color: rgb\(0, 0, 0\);">(.*?)<\/strong>/g, "<strong>$1</strong>").replace(/<em style="color: rgb\(0, 0, 0\);">(.*?)<\/em>/g, "<em>$1</em>");
    setEditorText(modifiedContent);
    changeHandler(modifiedContent);
  };

  const modules = {
    toolbar: toolbarOptions,
    clipboard: { matchVisual: false }
  };

  return (
    <div className="richTextArea">
      {customControlData?.showCustomControls && (
        <CustomControls
          bookmarkStatus={customControlData.bookmarkStatus}
          setBookmarkStatus={customControlData.setBookmarkStatus}
          recipientType={customControlData.recipientType}
          setRecipientType={customControlData.setRecipientType}
        />
      )}
      <ReactQuill value={editorText} onChange={handleEditorChange} modules={modules} placeholder={placeHolder} className="custom-scroll-bar richTextArea__richtext-editor" />
      {showCount ? (
        <div className="richTextArea__word-count-container">
          {textValue.length > wordLimit ? (
            <span className="richTextArea__word-count-container__limit">
              <Icon name="hrainfo" />
            </span>
          ) : null}
          <div className={`richTextArea__word-count-container__count ${textValue.length > wordLimit ? "word-limit-reached-indicator" : ""}`}>
            {textValue.length}/{wordLimit} characters
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default RichTextEditor;